import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AppService } from 'app/app.service';
import { ImageModule } from 'primeng/image';

@Component({
  selector: 'app-flights-legend-help',
  standalone: true,
  imports: [
    CommonModule,
    ImageModule
  ],
  templateUrl: './flights-legend-help.component.html',
  styleUrl: './flights-legend-help.component.scss'
})
export class FlightsLegendHelpComponent implements OnInit {


  legendItems: string[] = []

  constructor(
    public appService: AppService,
  ) { }

  ngOnInit(): void {
    this.legendItems = this.loadLegendItems();
  }

  loadLegendItems(): string[] {
    return [
      `Date of the flight based on user preference of UTC or Local time.`,
      `Flight number for this specific flight.`,
      `The equipment type for this specific flight.`,
      `The equipment nose number, not the registration.`,
      `Flight type, which will be designated with a Flight, Deadhead or Cancelled tag of green, yellow or red respectively.`,
      `The departure time from the station. The time listed first is based on user preferences of either local or UTC.`,
      `Block time for the event. Cancelled flights will not show a block time, those will display a time of 0:00.`,
      `The arrival time to the station. The time listed first is based on user preferences of either local or UTC.`,
      `Icon will change based on type of flight, Flight, Deadhead or Cancelled. If the icon, line and station names are red this corresponds to a cancelled flight.`,
    ];
  }
}
